import BaseAPI from "../api";
import { AxiosResponse } from 'axios';

const path: string = "/examination-calendar-student-view";

export class ExaminationCalendarStudentViewApi extends BaseAPI {
  static list(query: any): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<AxiosResponse> {
    return this.api.post(`${path}`, body);
  }
  static delete(id: any): Promise<AxiosResponse> {
    return this.api.delete(`${path}/${id}`);
  }
}